import WizardCard from "../../components/WizardCard"
import CheckmarkListItem from "../../components/CheckmarkListItem"

export interface LiabilityInsuranceCoverageCardProps {
  eyebrow: string
  heading: string
  subheading: string
  list: string[]
  price: string
  minPremium: string
}

const LiabilityInsuranceCoverageCard = ({
  eyebrow,
  heading,
  subheading,
  list,
  price,
  minPremium,
}: LiabilityInsuranceCoverageCardProps) => (
  <WizardCard>
    <div
      className="relative h-full flex flex-col p-6"
      data-testid="liability-insurance-coverage-card"
    >
      <p className="text-overline" data-testid="eyebrow">
        {eyebrow}
      </p>

      <h3
        className="flex items-center gap-3 text-charcoal-500 text-2xl font-display font-medium leading-[124%] tracking-[0.48px] mt-2"
        data-testid="heading"
      >
        {heading}
      </h3>

      <p
        className="text-dusk-500 font-body leading-[140%] tracking-[0.32px] mt-2"
        data-testid="subheading"
      >
        {subheading}
      </p>

      <ul className="grid grid-cols-1 gap-5 mt-[26px] mb-8">
        {list.map((item) => (
          <CheckmarkListItem key={item}>{item}</CheckmarkListItem>
        ))}
      </ul>

      <hr className="border-cloud-500 mb-4 mt-auto" />

      <div className="flex flex-col gap-2 mt-2">
        <p
          className="text-xl font-display font-medium leading-[124%] tracking-[0.48px]"
          data-testid="price"
        >
          starting at ${price}/acre
        </p>

        <p
          className="text-dusk-500 font-body leading-[140%] tracking-[0.32px]"
          data-testid="min-premium"
        >
          Minimum premium ${minPremium}
        </p>
      </div>
    </div>
  </WizardCard>
)

export default LiabilityInsuranceCoverageCard
